import { Grid } from "@mui/material";
import { useEffect } from "react";
import { wealthSourceOptions } from "../utils/pickListOptions";
import {
  WealthSourceOptions,
  setOtherWealthSource,
  setReduxSourceOfFunds,
} from "src/store/features/onboarding.slice";
import { StyledErrorField, StyledTextField } from "./AddressFields";
import { Field, useFormikContext } from "formik";
import { useAppDispatch } from "src/store/store";
import { FormValues } from "../utils/formSchema";
import { StyledEndAdorment } from "../AddressLookup";
import { batch } from "react-redux";
import { Label } from "../SelectAccountType";

export default function ReKycWealthSource() {
  const { setFieldValue } = useFormikContext();
  const dispatch = useAppDispatch();

  const {
    values: { otherWealthSource, wealthSource },
    errors: { wealthSource: wealthSourceError },
  } = useFormikContext<FormValues>();

  useEffect(() => {
    batch(() => {
      dispatch(setReduxSourceOfFunds(wealthSource));
      dispatch(setOtherWealthSource(otherWealthSource));
    });
  }, [wealthSource, otherWealthSource]);

  const handleMultiSelect = (option: WealthSourceOptions) => {
    // Check if wealthSource already includes the selected option.
    if (wealthSource.includes(option)) {
      // If it does, filter out the selected option from the array.
      const newWealthSource = wealthSource.filter((item) => item !== option);
      setFieldValue("wealthSource", newWealthSource);
    } else {
      // If it doesn't, push the selected option to the array.
      setFieldValue("wealthSource", [...wealthSource, option]);
    }
  };

  const sourceOfFundsOtherSelected = wealthSource.find((item) => item === "Others");

  return (
    <div>
      <Grid container spacing={1}>
        <Grid item xs={12} mt={2} mb={1}>
          <Label text="Which of the following are sources of the funds that you will be using with Caleb & Brown?" />
        </Grid>
        {wealthSourceOptions.map((option) => {
          return (
            <Grid
              item
              xs={6}
              sm={4}
              md={3}
              lg={2.2}
              onClick={() => handleMultiSelect(option.value)}
              key={option.value}>
              <StyledTextField
                value={option.label}
                custombgcolour={"#F0FEF9"}
                selected={wealthSource.includes(option.value)}
                disabled
                style={{ pointerEvents: "none" }}
                InputProps={{
                  endAdornment: (
                    <StyledEndAdorment selected={wealthSource.includes(option.value)} />
                  ),
                }}
              />
            </Grid>
          );
        })}
        {sourceOfFundsOtherSelected && (
          <Grid item xs={12}>
            <Field
              as={StyledTextField}
              name={"otherWealthSource"}
              label={"Enter Source of Funds here"}
              selected={!!sourceOfFundsOtherSelected}
              InputProps={{
                endAdornment: <StyledEndAdorment selected={otherWealthSource !== ""} />,
              }}
            />
          </Grid>
        )}
        {/* wealthSourceError error */}
        <Grid item xs={12}>
          {wealthSourceError && <StyledErrorField>{wealthSourceError}</StyledErrorField>}
        </Grid>
      </Grid>
    </div>
  );
}
